import React from 'react';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';
import { useDispatch } from 'react-redux';

import type { PublicApiSettingsJson } from '@/domain/payment/service/entity/publicApiSettingsEntity';

import { api, service } from '@/share';

/** プロパティ */
export type Props = {
  /** ID */
  id: PublicApiSettingsJson,
  /** 登録 */
  regist: (token: string) => void,
  /** 閉じる */
  close: () => void,
}

/**
 * クレジットカード登録
 * localhostの場合は以下のカード番号を使用できる。
 * Visa             4111 1111 1111 1111 111
 * Mastercard       5105 1051 0510 5100 111
 * Discover         6011 0000 0000 0004 111
 * Diners Club      3000 000000 0004    111
 * JCB              3569 9900 1009 5841 111
 * American Express 3400 000000 00009   1111
 * China UnionPay   6222 9888 1234 0000 123
 * Square Gift Card 7783 3200 0000 0000
 */
const CreditCardTokenForm: React.FC<Props> = ({
  id,
  regist,
  close,
}) => {
  const dispatch = useDispatch();
  const [error, setError] = React.useState<'ok' | 'error' | undefined>(undefined);
  React.useEffect(() => {
    const execProcess = async () => {
      try {
        await service.payment.attachCreditCard({
          appId: id.squareApplicationId,
          locationId: id.squareLocationId,
        }, '#card-container');
        setError('ok');
      } catch (e) {
        setError('error');
      }
    };
    execProcess();
  }, [id, dispatch]);
  let message = '初期化中です。お待ちください...';
  if (error === 'ok') {
    message = 'クレジットカード情報を入力して「登録ボタン」を押してください。';
  } else if (error === 'error') {
    message = 'エラーが起きました。施設にお問い合わせください。';
  }
  return (
    <Dialog open>
      <DialogTitle style={{ textAlign: 'center' }}>
        クレジットカードの登録
      </DialogTitle>
      <DialogContent>
        <p>{message}</p>
        <div id="card-container" />
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center' }}>
        <Button
          onClick={async () => {
            close();
          }}
        >
          閉じる
        </Button>
        <Button
          onClick={async () => {
            const result = await api.paymentApi.tokenize();
            if (result.error === '') {
              regist(result.token);
              close();
            }
          }}
          disabled={error !== 'ok'}
        >
          登録
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreditCardTokenForm;
